
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","d":"M11.291 11.268H36.53v3.374H11.291zM12.358 12.955h11.24"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M10.791 8.078h9.84v1.695h-9.84zM10.791 23.945h7.181v1.695h-7.181z"}}),_c('circle',{attrs:{"cx":"12.978","cy":"28.97","r":"1.687","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"23.91","cy":"28.97","r":"1.687","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"18.444","cy":"28.97","r":"2.187","fill":"#D0EFEC"}}),_c('circle',{attrs:{"cx":"1.003","cy":"1.003","r":".503","stroke":"#234652","transform":"matrix(1 0 0 -1 17.441 29.973)"}}),_c('circle',{attrs:{"cx":"29.377","cy":"28.97","r":"1.687","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"34.843","cy":"28.97","r":"1.687","stroke":"#234652"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M11.432 34.715h12.903v5.134H11.432z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M11.291 34.869h11.324v3.374H11.291zM36.53 18.056v3.374H11.291v-3.375zM12.358 19.743h4.374M34.47 19.743h.745"}}),_c('rect',{attrs:{"width":"33.117","height":"41.916","x":"7.442","y":"3.042","stroke":"#234652","rx":"1.5"}}),_c('path',{attrs:{"stroke":"#234652","d":"M33.14 18.2v3"}})])
          )
        }
      }
    